module.exports = __webpack_public_path__ + "static/media/Thistle.02470bc1.png";